import Input from '../General/Input'
import styled from 'styled-components'
import Select from '../General/Select'
import Button from '../General/Button'
import { useDispatch, useSelector } from 'react-redux'
import { getCountryList, submitEnquiry, getCertificateList, openEnquiryModal, getPharmacopoeiaGrades, setFileData, deleteFile } from '../../store/CoreSlice'
import { useState, useEffect, useRef } from 'react';
import enquiryFormSchema from '../../validations/Enquiry';
import { useFormik } from 'formik';
import EnquirySuccess from '../Layout/EnquirySuccess';
import EnquiryForm from '../Layout/EnquiryForm';
import TextArea from '../General/TextArea'
import FileInput from '../General/FileInput'
import helpers from '../../utils/helpers'
import DatePicker from '../General/DatePicker'

const StyledQuantitySuffix = styled.div`
	border-radius : 0px;
	width : 35px;
	height : 35px;
`

function GetInTouch({ product, ID, CASNumber } : any) {

	let initialValues : {[k: string]: any} = {
		// Autocomplete fields
		product_string : product,
		country_string : '',

		product : ID,
		quantity : null,
		price : null,
		expected_date : null,
		unit : 1,
		message : '',
		required_manufacturer : '',
		shipping_terms : '',

		// selected fields
		expected_certificates : [],
		pharmacopoeia_grades : [],
	}

	const [showCountryResults, setShowCountryResults] = useState(false);
	const [countryString, setCountryString] = useState('');
	
	const dispatch: any = useDispatch();
	const { user } = useSelector((state: any) => state.auth)
	const { countryList, certificateList, pharmacopoeiaGradesList, enquiryState, files } = useSelector((state: any) => state.core);

	const { values, errors, handleSubmit, handleBlur, handleChange, touched, resetForm, setFieldValue } = useFormik({
		initialValues: initialValues,
		validationSchema: enquiryFormSchema,

		onSubmit: (values, action) => {
			helpers.consoleLog('jnjdwnj')
			const payload = {...values};
			payload['attachment'] = files.length ? files[0].id : null;

			// In case a Product String is there but not selected any predefined product.
			if(payload.product_string !== '' && payload.product === null) {
				payload.product_text = payload.product_string;
				setFieldValue('product_text', payload.product_string)
			}

			if(user.isLoggedIn) {
				dispatch(submitEnquiry(payload));
			}
			else {
				dispatch(openEnquiryModal(payload));
			}
		}
	});
	
	useEffect(() => {
		dispatch(getCertificateList());
		dispatch(getPharmacopoeiaGrades());
	}, []);

	useEffect(() => {
		if (enquiryState.showSuccessModal) {
			resetEnquiryForm();
		}
	}, [enquiryState.showSuccessModal])

	const handleCountrySearch = (event : any) => {
		setCountryString(() => event.target.value);
		setFieldValue('country_string', event.target.value);
		setShowCountryResults(() => true);
		const params = {
			search: event.target.value
		}
		dispatch(getCountryList(params));

		if(event.target.value == '') 
			setFieldValue('country', null);
	}

	const selectCountry = (data: any) => {
		setCountryString(() => data.name);
		setFieldValue('country_string', data.name);
		setFieldValue('country',data.id);
		setShowCountryResults(() => false);
	}

	const handleCountryClear = () => {
		setCountryString(() => '');
		values.country_string = '';
		setFieldValue('country_string', '');
		setFieldValue('country', null);
	}

	const resetEnquiryForm = () => {
		resetForm();
		setCountryString('');
		dispatch(setFileData({
			data : [],
			action : 'replace'
		}));
	}

	console.log(errors);
	

	return (
		<>
			<div className='rounded-lg py-5 box-border' style={{ background: 'rgba(103, 124, 187)', boxShadow: '0px 3px 39px #EAE7E76C' }}>
				<form onSubmit={handleSubmit} className={`px-4 grid grid-cols-1 gap-4 md:px-10 py-4 lg:px-4`}>
					<div className=''>
						<Input
							disabled
							className='mb-3'
							label='Product Name'
							background='#8798c9'
							color='white'
							outerProperties='rounded py-[10px]'
							value={values.product_string}
							properties = 'placeholder:text-[#C3CCE4]'
						/>
					</div>
					
				
					<div className=''>
						<Input
							className='mb-3'
							label='Quantity'
							placeholder='eg. 10'
							background='#8798c9'
							color='white'
							outerProperties='rounded py-0.5'
							suffix={
								<StyledQuantitySuffix className='text-white bg-transparent m-1 text-sm flex justify-center items-center border-l border-[#A9B5D8]'>
									KG
								</StyledQuantitySuffix>
							}
							onChange={handleChange}
							name='quantity'
							value={values.quantity}
							onBlur={handleBlur}
							error={errors.quantity}
							touched={touched.quantity}
							properties = 'placeholder:text-[#C3CCE4]'
						/>
					</div>

					<Input
						className='mb-3'
						label='Budget'
						placeholder='eg. 220'
						background='#8798c9'
						color='white'
						outerProperties='rounded py-0.5'
						suffix={
							<StyledQuantitySuffix className='text-white bg-transparent p-2 m-1 text-sm flex justify-center items-center border-l border-[#A9B5D8]'>
								$
							</StyledQuantitySuffix>
						}
						onChange={handleChange}
						name='price'
						value={values.price}
						onBlur={handleBlur}
						error={errors.price}
						touched={touched.price}
						properties = 'placeholder:text-[#C3CCE4]'
					/>
					
					<div className='relative'>
						<Input
							label='Target Market'
							placeholder='eg. USA'
							search
							onInput={handleCountrySearch}
							name = 'country_string'
							value={countryString}
							background='#8798c9'
							color='white'
							outerProperties={`rounded ${!countryString && 'py-[11.5px]'}`}
							error={errors.country_string}
							touched={touched.country_string}
							onBlur = {(e : any) => {
								setTimeout(() => {
									setShowCountryResults(false);
									handleBlur(e)
								}, 300);
							}}
							searchResults={
								showCountryResults &&
								countryList.list.map((data: any, index: number) => (
									<div className="
												flex 
												justify-between 
												text-[12px] 
												my-1 
												py-2 
												text-theme-black 
												font-light 
												cursor-pointer 
												rounded 
												items-center 
												hover:bg-[#D4D9E7]/50 
												font-semibold"
										onClick={() => selectCountry(data)}
										key={index}
									>
										<p className="flex flex-col font-light">
											<span>
												{data.name}
											</span>
										</p>
									</div>
								))
							}
							suffix={
								countryString &&
								<div onClick={handleCountryClear} className='cursor-pointer text-white p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
									</svg>
								</div>
							}
							properties = 'placeholder:text-[#C3CCE4]'
						/>
					</div>

					<DatePicker
						className='mb-3'
						label='Delivery Date'
						background='#8798c9'
						color='white'
						outerProperties='rounded py-0.5'
						suffix={
							<StyledQuantitySuffix className='text-white bg-transparent p-2 m-1 text-sm flex justify-center items-center border-l border-[#A9B5D8]'>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
									<path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
								</svg>
							</StyledQuantitySuffix>
						}
						name='expected_date'
						onBlur={handleBlur}
						error={errors.expected_date}
						touched={touched.expected_date}
						properties = 'placeholder:text-[#C3CCE4]'
						minimumDate = {new Date()}
						initialValue = {values.expected_date}
						onChange = {(date : any) => setFieldValue('expected_date', date)}
					/>

					<Input
						className='mb-3'
						label='Required Manufacturer'
                        labelColor = 'white'
                        background='#8798c9'
						color='white'
						outerProperties='rounded py-[11px]'
						onChange={handleChange}
						name='required_manufacturer'
						value={values.required_manufacturer}
						onBlur={handleBlur}
						error={errors.required_manufacturer}
						touched={touched.required_manufacturer}
					/>

					<div>
						<label className='inline-block mb-1 text-white'> Certificates </label>
						<Select
							search
							color='white'
							placeholder='eg. GMP, DMF'
							background='#8798c9'
							additionalStyles={{
								border: 'none',
								padding: '2px 0'
							}}
							multi
							suffix={
								<StyledQuantitySuffix className='text-white bg-transparent border-l border-[#A9B5D8] p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
									</svg>
								</StyledQuantitySuffix>
							}
							items={certificateList.list}
							onChange={(selected : any) => setFieldValue('expected_certificates', selected)}
							error={errors.expected_certificates}
							placeholderColor = "#C3CCE4"
							placeholderStyles = {{
								fontSize : 13,
								fontWeight : 300
							}}
							name = "expected_certificates"
							value = {values.expected_certificates}
							touched = {touched.expected_certificates}
						/>
					</div>

					<div>
						<label className='inline-block mb-1 text-white'> Pharmacopoeia Grades </label>
						<Select
							search
							color='white'
							placeholder='eg. USP, IP'
                            background='#8798c9'
							additionalStyles={{
								border: 'none',
								padding: '2px 0'
							}}
							multi
							suffix={
								<StyledQuantitySuffix className='text-white bg-transparent border-l border-[#A9B5D8] p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
									</svg>
								</StyledQuantitySuffix>
							}
							items={pharmacopoeiaGradesList.list}
							onChange={(selected : any) => setFieldValue('pharmacopoeia_grades', selected)}
							placeholderColor = "#C3CCE4"
							placeholderStyles={{
								fontSize: 13,
								fontWeight: 300
							}}
							name = 'pharmacopoeia_grades'
							value = {values.pharmacopoeia_grades}
							error={errors.pharmacopoeia_grades}
							touched = {touched.pharmacopoeia_grades}
						/>
					</div>

					<div>
						<label className='inline-block mb-1 text-white'> Attach a file </label>
						<FileInput 
							name='attachment' 
							uniqueID = "enquiry__attachment" 
							disabled = {files.length}
							error = {errors.attachment}
						>
							<div className='flex justify-between items-center bg-[#8798c9] py-[2px] rounded text-sm font-light pl-2 text-[gray]'>
								{	
									files.length === 0 ?
									<span className='text-white opacity-[0.5]'>Browse</span> 
									:
									<span className='flex text-white opacity-[0.5]'>  
										{ files.length && helpers.reduceStringLength(files[0].name) }
										<svg onClick={() => dispatch(deleteFile(files[0].id))} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 ml-2">
											<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
										</svg>
									</span>
								}
								<StyledQuantitySuffix className='text-white bg-transparent border-l border-[#A9B5D8] p-2 m-1 text-sm flex justify-center items-center'>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
										<path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
									</svg>
								</StyledQuantitySuffix>
							</div>
						</FileInput>
					</div>

					<Input
						className='mb-3'
						label='Shipping Terms'
                        labelColor = 'white'
                        background='#8798c9'
						color='white'
						placeholder = 'Enter Shipping terms'
						outerProperties='rounded py-[11px]'
						properties = 'placeholder:text-white placeholder:opacity-[0.5]'
						onChange={handleChange}
						name='shipping_terms'
						value={values.shipping_terms}
						onBlur={handleBlur}
						error={errors.shipping_terms}
						touched={touched.shipping_terms}
					/>

					<div className='col-span-full'>
						<TextArea
							outerProperties='w-full mt-3 pt-3 rounded placeholder:text-[#C3CCE4] placeholder:text-sm placeholder:font-light placeholder:text-[white]'
							background = '#8798c9'
							properties = 'placeholder:text-white placeholder:opacity-[0.5]'
							color = 'white'
							rows={4}
							placeholder="Any Additional Comments?"
							onChange={handleChange}
							name='message'
							value={values.message}
							onBlur={handleBlur}
						/>
					</div>

					<Button type = "submit" styles='w-full text-white bg-theme-orange h-12 mt-4'> Submit </Button>
				</form>
			</div>

			<EnquiryForm 
				data={values}
				payload={values}
				countryList = {countryList.fixedList}
			/>

			<EnquirySuccess
				show={enquiryState.showSuccessModal}
				user={enquiryState.responseData ? enquiryState.responseData.user : ''} />
		</>
	)
}

export default GetInTouch